import { SchoolType } from "@interfaces/school"
import MiscRepo from "@lib/api/server-side/misc.repo"
import SchoolRepo from "@lib/api/server-side/school.repo"
import BootcampListPage from "@modules/program-list/pages/BootcampListPage"
import { GetServerSideProps } from "next"

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const school = new SchoolRepo()
  const misc = new MiscRepo()

  try {
    const userAgent = req.headers["user-agent"]
    const res =  school.schoolList(
      query.type ? (query.type as SchoolType) : "BOOTCAMP",
      userAgent
    )
    const res2 =  school.videoTestimonies(userAgent)
    const res3 =  misc.getBannerInfo(userAgent)

    let videoTestimonies = []
    const [schoolDetail, vt, bi] = await Promise.all([res, res2, res3])

    let bootcamps = []
    let bannerInfo

    if (vt.statusCode === 200) {
      const videoResult = JSON.parse(vt.body).result
      if (videoResult) {
        videoTestimonies = videoResult
      }
    }

    if (schoolDetail.statusCode === 200) {
      const result = JSON.parse(schoolDetail.body).result

      if (result) {
        bootcamps = result.data
      }
    }

    if (bi.statusCode === 200) {
      const result = JSON.parse(bi.body).result

      if (result) {
        bannerInfo = result
      }
    }
    
    return {
      props: {
        bootcamps,
        videoTestimonies,
        bannerInfo,
      },
    }
  } catch (e) {
    console.log(e)

    return {
      props: {
        bootcamps: [],
      },
    }
  }
}

export default BootcampListPage
